import { Button, Dropdown } from "components/ui";
import { PLACEMENT } from "components/ui/utils/constant";
import { useEffect, useRef, useState } from "react";
import { Trans } from "react-i18next";
import { MdCategory } from "react-icons/md";
import { TbCategory, TbSearch } from "react-icons/tb";
import { useYoutube } from "utils/hooks/socials/useYoutube";

const CategoryDropdown = ({
    post,
    isEditable = true,
    onChange = (category_id) => void 0,
    portal = false
}) => {
    const [ isLoading, setIsLoading ] = useState(false);
    const [ categories, setCategories ] = useState([]);
    const [ searchQuery, setSearchQuery ] = useState('');
    const { getYoutubeCategories } = useYoutube();
    const searchRef = useRef();

    const category = categories?.find(e => e.id == post?.preferences?.category_id);
    
    const getCategories = async () => {
        setIsLoading(true);
        const _categories = await getYoutubeCategories();
        setCategories(_categories);
        setIsLoading(false);
    }

    const onSearch = (value) => {
        setSearchQuery(value?.toLowerCase()?.trim());
    }

    const filteredCategories = categories?.filter(cat => {
        if (!searchQuery) return cat.assignable;
        return cat.assignable && cat.title?.toLowerCase().includes(searchQuery);
    });

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && filteredCategories?.length > 0) {
            onChange(filteredCategories[0]?.id);
            setSearchQuery('');
        }
    };

    useEffect(() => {
        getCategories()
    }, []);

    return (
        <Dropdown
            placement={PLACEMENT.BOTTOM_START}
            parentClassName="w-full"
            menuClass={`${portal ? "" : "w-full"} max-w-[300px] max-h-[300px] overflow-y-auto`}
            portal={portal}
            disabled={isLoading || !isEditable}
            onClick={() => {
                setSearchQuery('');
            }}
            onKeyDown={handleKeyDown}
            renderTitle={
                <Button
                    shape="rounded"
                    size={"sm"}
                    className="!rounded-none w-full !p-4 !h-auto border-b border-gray-100 dark:border-gray-700"
                    loading={isLoading}
                    disabled={isLoading || !isEditable}
                >
                    {isLoading 
                        ? <>Loading Categories...</>
                        : !!category
                            ? <div className='flex items-center gap-2'>
                                <TbCategory className='text-primary-600 text-2xl shrink-0' />
                                <span>{category.title}</span>
                            </div>
                            : <div className='flex items-center gap-2'>
                                <TbCategory className='text-2xl shrink-0' />
                                <span><Trans i18nKey={`postModalYoutube.selectCategory`}>Select Category</Trans></span>
                            </div>
                    }
                </Button>
            }
        >
            <Dropdown.Item variant="header" className="!p-2">
                <div className="flex items-center gap-2 w-full">
                    <div className="relative flex-1">
                        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-tertiary-400">
                            <TbSearch className="text-lg" />
                        </div>
                        <input
                            value={searchQuery}
                            autoFocus
                            ref={searchRef}
                            className="w-full h-9 pl-9 pr-4 rounded-lg text-sm border border-tertiary-100 dark:border-gray-600 bg-transparent focus:outline-none focus:ring-1 focus:ring-primary-500 dark:text-gray-100"
                            placeholder="Search..."
                            onChange={(e) => onSearch(e.target.value)}
                            onKeyDown={(e) => e.key == 'Enter' && onChange(filteredCategories?.[0]?.id)}
                        />
                    </div>
                </div>
            </Dropdown.Item>
            {filteredCategories?.map((category, key) => (
                <Dropdown.Item 
                    key={key} 
                    onClick={() => onChange(category.id)} 
                    className={`flex items-center gap-2 py-2 px-4 ${post?.preferences?.category_id == category.id && `bg-primary-50 dark:bg-primary-900`}`}
                >
                    <span className="text-ellipsis block">{category.title}</span>
                </Dropdown.Item>
            ))}
        </Dropdown>
    )
}

export default CategoryDropdown; 